import ExternalScriptLoader from './external-script-loader'

class Teads extends ExternalScriptLoader {
  scriptUrl = 'https://a.teads.tv/analytics/tag.js'

  init() {
    window.teads_analytics = window.teads_analytics || {}
    window.teads_analytics.analytics_tag_id = 'PUB_21440'
    window.teads_analytics.share =
      window.teads_analytics.share ||
      function () {
        ;(window.teads_analytics.shared_data = window.teads_analytics.shared_data || []).push(arguments)
      }
  }
}

export default new Teads()
